var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsSaveViewFilledIcon = function SvgDsSaveViewFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.428 1.797C3.132.99 4.15.667 5.026.667h5.503c1.01 0 2.003.443 2.672 1.112.653.653 1.112 1.55 1.112 2.58v9.08c0 .334-.143.718-.254.94-.156.312-.444.6-.756.756-.29.145-.575.16-.758.162-.46.11-.9-.036-1.21-.299l-3.47-1.818-3.573 1.829a1.704 1.704 0 0 1-.916.288H3.33c-.227.001-.537.002-.85-.14a1.6 1.6 0 0 1-.893-.778l-.007-.015a1.95 1.95 0 0 1-.247-.926V4.36c0-1.022.451-1.912 1.095-2.563m2.46 2.242a.667.667 0 0 0 0 1.333H8a.667.667 0 0 0 0-1.333z",
    clipRule: "evenodd"
  })));
};
export default SvgDsSaveViewFilledIcon;